import { render } from "./SecurityAccess.vue?vue&type=template&id=4ce0971c"
import script from "./SecurityAccess.vue?vue&type=script&lang=js"
export * from "./SecurityAccess.vue?vue&type=script&lang=js"

import "./SecurityAccess.vue?vue&type=style&index=0&id=4ce0971c&lang=css"
script.render = render

export default script